<script>
import { apiSecond } from '@/boot/axios'
import {
	hasNotificationHref,
	notificationHref,
	notificationLink,
	notificationText,
} from '@/helpers'

export default {
	data() {
		return {
			limit: 'limit',

			notifications: [],
			headers: [
				{ text: '№', value: 'id' },
				{ text: this.$t('headers.message'), value: 'data' },
				{ text: this.$t('headers.created_at'), value: 'created_at' },
				{ text: this.$t('template_text.viewed'), value: 'read_at' },
				{
					text: this.$t('headers.action'),
					value: 'action',
					align: 'left',
					sortable: false,
					width: '200px',
				},
			],
			options: {
				itemsPerPage: 10,
				page: 1,
			},
			errorMessage: {
				status: null,
				text: null,
			},
		}
	},
	props: {},
	watch: {},
	mounted() {
		this.getData()
	},
	methods: {
		notificationText,
		notificationLink,
		notificationHref,
		hasNotificationHref,
		getData() {
			apiSecond
				.get('v1/notifications/list', {
					params: {
						user_id: this.$store.state.userObject.id,
					},
				})
				.then((response) => {
					this.notifications = response.data
					this.$store.commit('getUserNotifications', response.data)
				})
				.catch((error) => {})
		},
		readSet(index, link) {
			apiSecond
				.post('v1/notifications/read', {
					index: index,
				})
				.then(() => {
					this.getData()
					// this.$router.push({ path: link });
					window.open(link, '_blank')
				})
				.catch(() => {})
		},
		eyeSet(index) {
			apiSecond
				.post('v1/notifications/read', {
					index: index,
				})
				.then(() => {
					this.getData()
				})
				.catch(() => {})
		},
	},

	beforeCreate() {
		if (!localStorage.token) {
			this.$router.push('/ru/login')
		}
	},
	head: {
		title() {
			return {
				inner: this.$t('notification.title'),
			}
		},
		meta: [],
	},
}
</script>

<template>
	<div
		class="wrap__content"
		v-bind:class="{ 'wrap__content--preloader': !$store.state.userObject }"
	>
		<v-preloader v-if="!$store.state.userObject" :message="errorMessage"></v-preloader>

		<div class="container" v-if="$store.state.userObject">
			<div class="row">
				<div class="col-xl-2 col-lg-3">
					<v-sidebar :active="['Notifications']"></v-sidebar>
				</div>
				<div class="col-xl-10 col-lg-9">
					<div class="content-wrapper">
						<div class="card__content">
							<div class="card__content-header">
								<div class="content__title">
									<div class="content__title--element">
										<div class="content__title--text">
											{{ $t('notification.title') }}
										</div>
									</div>
								</div>
							</div>
							<div class="card__content--body">
								<div class="table__block--content">
									<v-data-table
										:headers="headers"
										:items="notifications"
										:loading="false"
										:options.sync="options"
										:footer-props="{
											'items-per-page-options': [5, 10, 20, 30, 40, 50],
										}"
									>
										<template v-slot:item.id="{ item, index }">
											{{ index + 1 }}
										</template>
										<template v-slot:item.created_at="{ item }">
											{{ item.created_at | formatDate }}
										</template>
										<template v-slot:item.data="{ item, index }">
											<a
												class="pointer"
												v-if="notificationLink(item)"
												@click="readSet(index, notificationLink(item))"
												target="_blank"
											>
												<span>{{ notificationText(item) }}</span>
											</a>
											<a
												class="pointer"
												v-else-if="hasNotificationHref(item)"
												@click="readSet(index, notificationHref(item))"
											>
												<span>{{ notificationText(item) }}</span>
											</a>
											<span v-else>{{ notificationText(item) }}</span>
										</template>
										<template v-slot:item.read_at="{ item }">
											<a class="tb__table--status" :class="{ 'tb__status--success': item.read_at }">
												{{ item.read_at ? $t('template_text.viewed') : $t('template_text.new') }}
											</a>
										</template>
										<template v-slot:item.action="{ item, index }">
											<div class="flex">
												<a
													v-if="notificationLink(item)"
													class="tb__table--btn pointer"
													:href="notificationLink(item)"
													target="_blank"
													v-tooltip.top-center="{
														content: $t('tooltip.go'),
														class: ['tooltip__btn'],
													}"
												>
													<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6.75 15.75h-3a1.5 1.5 0 01-1.5-1.5V3.75a1.5 1.5 0 011.5-1.5h3M12 12.75L15.75 9 12 5.25M15.75 9h-9" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
												</a>
												<a
													v-else-if="hasNotificationHref(item)"
													class="tb__table--btn pointer"
													@click="readSet(index, notificationHref(item))"
													v-tooltip.top-center="{
														content: $t('tooltip.go'),
														class: ['tooltip__btn'],
													}"
												>
													<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M6.75 15.75h-3a1.5 1.5 0 01-1.5-1.5V3.75a1.5 1.5 0 011.5-1.5h3M12 12.75L15.75 9 12 5.25M15.75 9h-9" stroke="#52A5FC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
												</a>
											</div>
										</template>
									</v-data-table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
